<template>
  <search-custom-dropdown
    v-model="searchInput.filterBtn.state"
    :search-input-text="searchInput.filterBtn.text"
    :is-filled="displayFilterText() ? true : false"
    :display-icon="true"
    :width="0"
  >
    <template v-slot:drop-content>
      <keyword-input
        :initial-keywords="lastNewQuery.query.Keywords"
        @update-keyword="updateKeyword"
      />
      <range-input-dropdown
        v-for="rangeField in displayRangeInputFields"
        :key="rangeField.key"
        :initial-value="lastNewQuery.query[rangeField.key]"
        :dropdown-options="rangeField.options"
        :select-params="rangeField.params"
        @update-value="updateRangeValue([rangeField.key], $event)"
      />
    </template>
  </search-custom-dropdown>
</template>

<script>
import { mapState } from 'vuex'
import searchLayoutHandler from '../../mixins/searchLayoutHandler'

export default {
  mixins: [searchLayoutHandler],

  computed: {
    ...mapState('home', ['windowWidth']),

    displayRangeInputFields() {
      return [
        { key: 'SqFt', options: this.areaOptions, params: this.areaParams },
        {
          key: 'LotSizeArea',
          options: this.lotSizeOptions,
          params: this.lotSizeParams
        },
        { key: 'YearBuilt', options: this.yearOptions, params: this.yearParams }
      ]
    }
  },

  methods: {
    addToFilter(value) {
      return this.searchObject.searchResult && this.windowWidth < value
    }
  }
}
</script>
